// extracted by mini-css-extract-plugin
export default {"WelcomeInfo":"WelcomeInfo_WelcomeInfo__iLg6u","imageContainer":"WelcomeInfo_imageContainer__JrFpz","image":"WelcomeInfo_image__AT+iF","help":"WelcomeInfo_help__wM1JK"};